import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "w-full flex flex-col justify-center" };
const _hoisted_2 = {
    role: "list",
    class: "space-y-4 px-6 md:flex md:space-y-0 md:space-x-8"
};
const _hoisted_3 = {
    key: 0,
    class: "group pl-4 py-2 flex flex-col border-l-4 border-button md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4"
};
const _hoisted_4 = { class: "text-xs text-button font-semibold tracking-wide uppercase" };
const _hoisted_5 = { class: "text-sm font-medium" };
const _hoisted_6 = {
    key: 1,
    class: "pl-4 py-2 flex flex-col border-l-4 border-button md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4",
    "aria-current": "step"
};
const _hoisted_7 = { class: "text-xs text-button font-semibold tracking-wide uppercase" };
const _hoisted_8 = { class: "text-sm font-medium" };
const _hoisted_9 = {
    key: 2,
    class: "group pl-4 py-2 flex flex-col border-l-4 border-gray-200 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4"
};
const _hoisted_10 = { class: "text-xs text-gray-500 font-semibold tracking-wide uppercase" };
const _hoisted_11 = { class: "text-sm font-medium" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "text-sm text-black px-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { key: 2 };
const _hoisted_17 = { class: "mb-2 px-6" };
const _hoisted_18 = { class: "inline" };
const _hoisted_19 = { class: "px-6" };
const _hoisted_20 = {
    key: 0,
    class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative m-5",
    role: "alert"
};
const _hoisted_21 = { class: "grid grid-cols-4 pt-2 bg-gray-200" };
const _hoisted_22 = { class: "text-xs" };
const _hoisted_23 = { key: 3 };
const _hoisted_24 = { class: "px-6" };
const _hoisted_25 = { class: "grid grid-cols-3 pt-2" };
const _hoisted_26 = ["onChange"];
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("input", {
    style: { "opacity": "0" },
    class: "h-0 w-0",
    autofocus: ""
}, null, -1);
const _hoisted_28 = [
    _hoisted_27
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Form = _resolveComponent("Form");
    const _component_Button = _resolveComponent("Button");
    const _component_modal = _resolveComponent("modal");
    return (_ctx.show)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            action: _ctx.step === 2 || _ctx.step === 3,
            onClose: _cache[8] || (_cache[8] = ($event) => (_ctx.closeModal()))
        }, _createSlots({
            header: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('invite.newInvite', {
                    role: _ctx.$t('role.vaultUser'),
                    duration: _ctx.invitationDuration,
                })), 1)
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("ol", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: step.name,
                                class: "md:flex-1"
                            }, [
                                (step.status === 'complete')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(step.id), 1),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(step.name), 1)
                                    ]))
                                    : (step.status === 'current')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(step.id), 1),
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(step.name), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(step.id), 1),
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(step.name), 1)
                                        ]))
                            ]));
                        }), 128))
                    ]),
                    (_ctx.step === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("p", _hoisted_13, [
                                _createTextVNode(_toDisplayString(_ctx.$t('invite.inviteMailNotification')) + " ", 1),
                                _hoisted_14,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('invite.inviteDuration', { duration: _ctx.invitationDuration })), 1)
                            ]),
                            _createVNode(_component_Form, {
                                class: "mt-2",
                                type: "submit",
                                "form-data": _ctx.form,
                                "onUpdate:form-data": _cache[0] || (_cache[0] = ($event) => ((_ctx.form) = $event)),
                                onSubmit: _ctx.validateFields,
                                onCancel: _ctx.closeModal
                            }, null, 8, ["form-data", "onSubmit", "onCancel"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_Form, {
                                class: "mt-2",
                                "form-data": _ctx.usernameForm,
                                "onUpdate:form-data": _cache[1] || (_cache[1] = ($event) => ((_ctx.usernameForm) = $event)),
                                onSubmit: _ctx.validateUsername,
                                onCancel: _ctx.previousStep
                            }, null, 8, ["form-data", "onSubmit", "onCancel"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createTextVNode(_toDisplayString(_ctx.$t('user.username')) + ": ", 1),
                                _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.userDetails.username), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('invite.writeDownSeedPhrase')), 1),
                            (_ctx.seedsShownAlready)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('invite.seedPhraseWarning')), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetails.seedPhrase.split(' '), (word, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: word + i,
                                        class: "text-center grid grid-cols-1 mb-2"
                                    }, [
                                        _createElementVNode("span", _hoisted_22, _toDisplayString(i + 1), 1),
                                        _createElementVNode("span", null, _toDisplayString(word), 1)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('invite.controlWords')), 1),
                            _createElementVNode("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.randomWordIndexes, (wordIndex, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "px-2",
                                        key: wordIndex + i
                                    }, [
                                        _createTextVNode(" Word " + _toDisplayString(wordIndex + 1) + " ", 1),
                                        _createElementVNode("input", {
                                            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event) => (_ctx.sendInvitation()), ["enter"])),
                                            class: "py-0 my-0",
                                            onChange: event => (_ctx.filledWords[i] = event.target.value)
                                        }, null, 40, _hoisted_26)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 2
        }, [
            (_ctx.step === 2 || _ctx.step === 3)
                ? {
                    name: "actions",
                    fn: _withCtx(() => [
                        _createElementVNode("form", {
                            id: "words",
                            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                            onKeypress: _cache[4] || (_cache[4] = _withKeys(($event) => (_ctx.nextStep()), ["enter"]))
                        }, _hoisted_28, 32),
                        (_ctx.step === 3)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                colored: "",
                                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.sendInvitation()))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('invite.invite')), 1)
                                ]),
                                _: 1
                            }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                colored: "",
                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.nextStep())),
                                type: "submit"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('misc.next')), 1)
                                ]),
                                _: 1
                            })),
                        _createVNode(_component_Button, {
                            class: "mr-2",
                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.previousStep()))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('misc.previous')), 1)
                            ]),
                            _: 1
                        })
                    ])
                }
                : undefined
        ]), 1032, ["action"]))
        : _createCommentVNode("", true);
}
